import React from "react"

function IconInfoRed() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" fill="none" viewBox="0 0 43 43">
      <path
        stroke="red"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.644"
        d="M21.192 16.415v6.609m15.861-1.322a15.862 15.862 0 11-31.724 0 15.862 15.862 0 0131.724 0zm-15.861 6.61h.014v.013h-.014v-.014z"
      ></path>
    </svg>
  )
}

export default IconInfoRed
